import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-global-dashboard-chart-skeleton',
  templateUrl: './global-dashboard-chart-skeleton.component.html',
  styleUrls: ['./global-dashboard-chart-skeleton.component.scss']
})
export class GlobalDashboardChartSkeletonComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
